import React, { useState, useEffect, useRef } from "react";
import { useQuery } from "@apollo/client";
import { GET_FIRST_YEAR } from "../graphql/queries";
import gsap from "gsap";

export default function Eerstejaar() {
    const { loading, error, data } = useQuery(GET_FIRST_YEAR);
    const [semester, setSemester] = useState("eerste");
    const courseCarouselRef = useRef(null);

    console.log({ loading, error, data });

    const colors = ["#c8b6ff", "#b8c0ff", "#e7c6ff"];

    const filterCourses = (courses) => {
        if (semester === "eerste") {
            return courses.filter(
                (item) => item.periode === 1 || item.periode === 2
            );
        } else {
            return courses.filter(
                (item) => item.periode === 3 || item.periode === 4
            );
        }
    };

    useEffect(() => {
        if (!loading && !error && data) {
            gsap.fromTo(
                courseCarouselRef.current.children,
                { opacity: 0, y: 20 },
                {
                    opacity: 1,
                    y: 0,
                    duration: 1,
                    stagger: 0.2,
                }
            );
        }
    }, [loading, error, data, semester]);

    if (loading) return <p>Loading...</p>;
    if (error) {
        console.error(error);
        return <p>Error : {error.message}</p>;
    }

    const filteredData = filterCourses(data.eersteJaars);

    return (
        <div className="jaar">
            <div className="semester-toggle">
                <h1> Eerste jaars</h1>
                <button
                    onClick={() => setSemester("eerste")}
                    className={semester === "eerste" ? "active" : ""}
                >
                    Eerste Semester
                </button>
                <button
                    onClick={() => setSemester("tweede")}
                    className={semester === "tweede" ? "active" : ""}
                >
                    Tweede Semester
                </button>
            </div>
            <div className="course-carousel" ref={courseCarouselRef}>
                {filteredData.map((item, index) => (
                    <div
                        key={index}
                        className="card-prog"
                        style={{
                            backgroundColor: colors[index % colors.length],
                        }}
                    >
                        <h4>{item.programma}</h4>
                        <p>{item.test}</p>
                        <p className="sp">{item.studiepunten} sp</p>
                        <p className="hour">{item.aantalUur} u/w</p>
                    </div>
                ))}
            </div>
        </div>
    );
}
